/* istanbul ignore file */
import React from 'react';

// Contexts
import Contexts from 'contexts';

// Routes
import Routes from './routes';

function App() {
  return (
    <Contexts>
      <Routes />
    </Contexts>
  );
}

export default App;
